import React, { useEffect, useState } from "react";
import { Row, Col, Card, CardBody, CardTitle, CardFooter } from "reactstrap";

// Import Breadcrumb
import ReactSpeedometer from "react-d3-speedometer";

import customer from "assets/images/customer.svg";
import staff from "assets/images/staff.svg";
import nozzle from "assets/images/nozzle.svg";

import shape1 from "assets/images/shape-01.png";
import shape2 from "assets/images/shape-02.png";
import shape3 from "assets/images/shape-03.png";
import shape4 from "assets/images/shape-04.png";
import { Link } from "react-router-dom";
import { get } from "helpers/api_helper";
import { DASHBOARD } from "helpers/url_helper";
import "flatpickr/dist/themes/material_blue.css";

const Dashboard = () => {
  const [customerData, setCustomerData] = useState();
  const [chartData, setChartData] = useState();
  const [chartLoader, setChartLoader] = useState(false);
  const [totalSoldDiesel, setTotalSoldDiesel] = useState([]);
  const [adminSold, setAdminSold] = useState([]);
  const [nozzles, setNozzles] = useState([]);
  const [profit, setProfit] = useState(0);
  const [loss, setLoss] = useState(0);
  const [nozzelCount, setNozzelCount] = useState({});
  const [fillerCount, setFillerCount] = useState({});
  const [expense, setExpense] = useState(0)

  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const role = authUser?.user?.role;

  const [breadcrumbItems] = useState([
    { title: "valfuel", link: "/" },
    { title: "Dashboard", link: "#" },
  ]);

  const [availableDiesel, setAvailableDiesel] = useState(0);

  // 1. First, update your state management
  const [fuelData, setFuelData] = useState({
    available: 0,
    capacity: 0,
    nozzleInfo: null,
    isAssigned: false,
  });

  // 2. Modify your useEffect to handle data properly
  useEffect(() => {
    async function getDashboardData() {
      try {
        const response = await get(DASHBOARD);
        console.log("Full API response:", response);

        // Extract data from the nested structure
        const apiData = response?.data || {};
        const isAssigned =
          apiData?.isNozzelAssigned || response?.isNozzelAssigned;
        const fillers = response?.fillers;
        const products = apiData?.products;
        const adminOrders = apiData?.orders?.orders || [];

        // console.log("Extracted data:", { isAssigned, fillers, products });
        console.log("User role:", role);
        console.log(response.fillers);
        console.log("fillers", fillers);

        if (role === 1 || role === 3) {
          const fillerDetails = response?.data?.fillerDetails || [];
          setNozzles(fillerDetails);

          const totalAvailable = fillerDetails.reduce((sum, nozzle) => {
            return sum + parseFloat(nozzle.remaining_capacity || 0);
          }, 0);
          const incomeData = parseFloat(apiData?.incomeData?.total_transactions) || 0;
          const profit = parseFloat(apiData?.orders?.profit) || 0;
          setProfit(profit + incomeData);
          setLoss(apiData?.orders?.loss || 0);
          setNozzelCount(apiData?.nozzelCount || {});
          setFillerCount(apiData?.fillerCount || {});
          setExpense(apiData?.expenseData?.total_transactions)
          const available = parseFloat(products?.toal_stock) || 0;
          setFuelData({
            available,
            capacity: 75000,
            nozzleInfo: null,
            isAssigned: true,
          });
          setCustomerData(apiData?.customers || {});
          const adminSoldTotal = adminOrders.reduce((sum, order) => {
            return sum + parseFloat(order.total_qty || 0);
          }, 0);
          setAdminSold(adminSoldTotal);
        } else {
          console.log(fillers);
          if (isAssigned && fillers) {
            const nozzleUlId = fillers.current_assigned_filler_ul_id;
            console.log("Expected nozzleUlId:", nozzleUlId);

            console.log("Order entries with nozzel_ul_id:");
            (response.orders || []).forEach((order) => {
              console.log(order.nozzel_ul_id, order.total_qty);
            });

            const fillerUlId = authUser?.user?.ul_id;
            const totalSold = (response.orders || [])
              .filter((order) => order.created_by_ul_id === fillerUlId)
              .reduce(
                (sum, order) => sum + parseFloat(order.total_qty || 0),
                0
              );

            setTotalSoldDiesel(totalSold);

            setFuelData({
              available: Math.max(
                0,
                parseFloat(fillers.remaining_capacity) || 0
              ),
              capacity: parseFloat(fillers.total_capacity) || 0,
              nozzleInfo: {
                number: fillers.nozzel_no,
                vehicle: fillers.vehicle_no,
                updatedAt: fillers.updatedAt,
              },
              isAssigned: true,
            });
          } else {
            setFuelData({
              available: 0,
              capacity: 0,
              nozzleInfo: null,
              isAssigned: false,
            });
          }
        }
      } catch (error) {
        console.error("Dashboard data error:", error);
      }
    }
    getDashboardData();
  }, []);

  return (
    <React.Fragment>
      <div className="page-content">
        <Row>
          <Col md={12}>
            <Card className="bg-dark">
              <div className="overlay-img">
                <img src={shape4} alt="img" className="img-fluid shape-01" />
                <img src={shape1} alt="img" className="img-fluid shape-02" />
                <img src={shape2} alt="img" className="img-fluid shape-03" />
                <img src={shape3} alt="img" className="img-fluid shape-04" />
              </div>
              <CardBody>
                <div className="d-flex align-items-xl-center justify-content-xl-between flex-xl-row flex-column">
                  <div className="mb-3 mb-xl-0">
                    <div className="d-flex align-items-center flex-wrap mb-2">
                      <h1 className="text-white me-2">
                        Welcome Back,{" "}
                        {authUser?.user?.name.toLowerCase() || "Admin"}
                      </h1>
                      <Link
                        href="/"
                        className="avatar avatar-sm img-rounded bg-gray-800 dark-hover"
                      >
                        <i className=" ri-pencil-line"></i>{" "}
                      </Link>
                    </div>
                    <p className="text-white">Have a Good day at work</p>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
        {role === 1 && (
          <>
            <Row>
              <Col xxl={3} sm={6} className="d-flex">
                <Card className="flex-fill animate-card">
                  <CardBody className="top_counter d-flex">
                    <div className="avatar avatar-xl bg-danger-transparent me-2 p-1">
                      <i className="mdi mdi-credit-card font-size-30"></i>{" "}
                    </div>
                    <div className="content flex-fill mt-2 ">
                      <span>Expected Loss</span>
                      <h5 className="number mb-0 font600">{loss || 0}</h5>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col xxl={3} sm={6} className="d-flex">
                <Card className="flex-fill animate-card">
                  <CardBody className="top_counter d-flex">
                    <div className="avatar avatar-xl bg-success-transparent me-2 p-1">
                      <i className="mdi mdi-card font-size-30"></i>{" "}
                    </div>
                    <div className="content flex-fill mt-2">
                      <span>Expected Profit</span>
                      <h5 className="number mb-0 font600">{profit || 0}</h5>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col xxl={3} sm={6} className="d-flex">
                <Card className="flex-fill animate-card">
                  <CardBody className="top_counter d-flex">
                    <div className="avatar avatar-xl bg-danger-transparent me-2 p-1">
                      <i className="mdi mdi-credit-card font-size-30"></i>{" "}
                    </div>
                    <div className="content flex-fill mt-2 ">
                      <span>Expense</span>
                      <h5 className="number mb-0 font600">{((Number(expense)) || 0).toFixed(2)}</h5>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col xxl={3} sm={6} className="d-flex">
                <Card className="flex-fill animate-card">
                  <CardBody className="top_counter d-flex">
                    <div className="avatar avatar-xl bg-success-transparent me-2 p-1">
                      <i className="mdi mdi-card font-size-30"></i>{" "}
                    </div>
                    <div className="content flex-fill mt-2 ">
                      <span>Net Profit</span>
                      <h5 className="number mb-0 font600">{((Number(profit) - Number(expense)) || 0).toFixed(2)}</h5>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </>
        )}

        <Row>
          {role !== 3 && (
            <Col lg={4} className="d-flex">
              <Card className="flex-fill">
                <div className="card-header  d-flex align-items-center justify-content-between">
                  <CardTitle className="h4 mb-0 d-flex ">
                    Total sell Diesel{" "}
                  </CardTitle>
                  <Link className="btn btn-sm btn-primary" to={"/add-order"}>
                    Order now{" "}
                  </Link>
                </div>
                <CardBody className="pb-0 text-center">
                  {chartLoader ? (
                    <div className="text-center">
                      <div className="spinner">
                        <i className="ri-loader-line spin-icon"></i>
                      </div>
                    </div>
                  ) : !chartData || chartData.length === 0 ? (
                    <ReactSpeedometer
                      maxValue={5000}
                      value={role === 1 ? adminSold || 0 : totalSoldDiesel || 0}
                      currentValueText={`${Number(
                        role === 1 ? adminSold || 0 : totalSoldDiesel || 0
                      ).toFixed(2)} Ltr Sold`}
                    />
                  ) : (
                    <div className="text-center mb-5">No Data available</div>
                  )}
                </CardBody>
              </Card>
            </Col>
          )}
          {role !== 3 && (
            <Col lg={4} className="d-flex">
              <Card className="flex-fill">
                <div className="card-header d-flex align-items-center justify-content-between">
                  <CardTitle className="h4 mb-0">
                    {role === 1 ? "Station Fuel" : "Nozzle Status"}
                  </CardTitle>
                  {fuelData.isAssigned && fuelData.nozzleInfo && (
                    <span className="badge bg-success">
                      Nozzle #{fuelData.nozzleInfo.number}
                    </span>
                  )}
                </div>
                <CardBody className="pb-0 text-center">
                  {fuelData.isAssigned ? (
                    fuelData.capacity > 0 ? (
                      <>
                        <ReactSpeedometer
                          value={fuelData.available}
                          maxValue={fuelData.capacity}
                          currentValueText={`${fuelData.available.toFixed(
                            2
                          )} Ltr`}
                          segments={5}
                        />
                        {fuelData.available < 0 && (
                          <div className="text-danger small mt-2">
                            Warning: Negative balance
                          </div>
                        )}
                      </>
                    ) : (
                      <div className="text-warning">Invalid capacity data</div>
                    )
                  ) : (
                    <div className="text-center">
                      <p className="text-muted mb-1">No nozzle assigned</p>
                      <small>Contact station admin</small>
                    </div>
                  )}
                </CardBody>
                {fuelData.isAssigned && fuelData.nozzleInfo && (
                  <CardFooter className="small text-center">
                    <div>Vehicle: {fuelData.nozzleInfo.vehicle}</div>
                    <div>
                      Updated:{" "}
                      {new Date(fuelData.nozzleInfo.updatedAt).toLocaleString()}
                    </div>
                  </CardFooter>
                )}
              </Card>
            </Col>
          )}
          {(role === 1 || role === 3) && (
            <Col lg={4}>
              <Card>
                <div className="card-header  d-flex align-items-center justify-content-between">
                  <CardTitle className="">Nozzle available Stock</CardTitle>
                </div>
                <CardBody className="text-center">
                  <div className="table-responsive">
                    <table className="table table-striped mb-0">
                      <thead>
                        <tr>
                          <th className="text-start">Nozzle NO</th>
                          <th>Filler Name</th>
                          <th className="text-end">Available Fuel</th>
                        </tr>
                      </thead>
                      <tbody>
                        {nozzles.map((nozzle, index) => (
                          <tr key={index}>
                            <td className="text-start">
                              Nozzle No:- {index + 1}
                            </td>
                            <td>{nozzle.name}</td>
                            <td className="text-end">
                              {parseFloat(nozzle.remaining_capacity).toFixed(2)}{" "}
                              Ltr
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          )}
        </Row>
        {role === 1 && (
          <Row>
            <Col lg={6} className="d-flex">
              {/* <Card className="flex-fill">
                <div className="card-header  d-flex align-items-center justify-content-between">
                  <CardTitle className="h4 mb-0">Incom/Expense</CardTitle>
                  <Dropdown
                    isOpen={dropdowns.fees}
                    toggle={() => toggle("fees")}
                  >
                    <DropdownToggle tag="button" className="btn btn-info">
                      {" "}
                      {formatPeriodLabel(chartRange)}{" "}
                      <i className="mdi mdi-chevron-down ms-1"></i>{" "}
                    </DropdownToggle>
                    <DropdownMenu end>
                      <DropdownItem
                        onClick={() => handleChartRangeChange("quarterly")}
                      >
                        Quarterly
                      </DropdownItem>
                      <DropdownItem
                        onClick={() => handleChartRangeChange("halfyearly")}
                      >
                        Half Yearly
                      </DropdownItem>
                      <DropdownItem
                        onClick={() => handleChartRangeChange("monthly")}
                      >
                        Monthly
                      </DropdownItem>
                      <DropdownItem
                        onClick={() => handleChartRangeChange("custom")}
                      >
                        Custom
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </div>

                <CardBody className="pb-0">
                  {chartLoader ? (
                    <div className="text-center">
                      <div className="spinner">
                        <i className="ri-loader-line spin-icon"></i>
                      </div>
                    </div>
                  ) : chartData && chartData?.length > 0 ? (
                    <IncomeExpenseChart
                      reportData={chartData}
                      range={chartRange}
                    />
                  ) : (
                    <div className="text-center mb-5">No Data available</div>
                  )}
                </CardBody>
              </Card> */}
              {/* {customPopupVisible && (
                <div style={popupOverlayStyle}>
                  <div style={popupBoxStyle}>
                    <h5>Select Custom Date Range</h5>
                    <Flatpickr
                      // value={[academicYearStartDate, academicYearEndDate]}
                      options={{
                        mode: "range",
                        dateFormat: "Y-m-d",
                        minDate: academicYearStartDate,
                        maxDate: academicYearEndDate,
                      }}
                      onChange={(date) => {
                        setCustomDateRange(date);
                        console.log(date);
                      }}
                      className="d-block form-control input active"
                      placeholder="Select date range"
                    />
                    <div className="mt-3 d-flex justify-content-end gap-2">
                      <button
                        className="btn btn-secondary"
                        onClick={() => setCustomPopupVisible(false)}
                      >
                        Cancel
                      </button>
                      <button
                        className="btn btn-primary"
                        onClick={handleCustomDateRange}
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                </div>
              )} */}
            </Col>
            <Col lg={6}>
              {/* <Card>
                <CardBody>
                  <h5 className=" text-danger">New Customers List</h5>
                  <div className="table-responsive">
                    <table className="table table-striped mb-0 text-nowrap">
                      <thead>
                        <tr>
                          <th>No</th>
                          <th>Full Name</th>
                          <th>Gender</th>
                          <th>Date Of Birth</th>
                          <th>Status</th>
                          <th>Blood Group</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {latestStudents?.map((student, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>
                              {student.name +
                                " " +
                                student.middle_name +
                                " " +
                                student.surname}
                            </td>
                            <td>{student.gender}</td>
                            <td>
                              {new Date(
                                student.date_of_birth
                              ).toLocaleDateString()}
                            </td>
                            <td>
                              <span className="badge bg-success-subtle text-success text-uppercase">
                                {student.status === 1 ? "active" : "inactive"}
                              </span>
                            </td>
                            <td>{student.blood_group}</td>
                            <td>
                              <a className="me-3 text-primary" href="/">
                                <i className="mdi mdi-pencil font-size-18"></i>
                              </a>
                              <a className="text-danger" href="/">
                                <i className="mdi mdi-trash-can font-size-18"></i>
                              </a>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </CardBody>
                <CardFooter className=" d-flex justify-content-between">
                  <div className="font-14">
                    <span>
                      Measure How Fast You’re Growing Monthly Recurring Revenue.{" "}
                      <a href="/">View All</a>
                    </span>
                  </div>
                  <div>
                    <button type="button" className="btn btn-primary">
                      Export
                    </button>
                  </div>
                </CardFooter>
              </Card> */}
            </Col>
          </Row>
        )}
        {role === 1 && (
          <Row>
            <Col xl={4} sm={6} className="d-flex">
              <Card className="flex-fill animate-card border-0">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-xl bg-danger-transparent me-2 p-1">
                      <img src={customer} alt="img" />
                    </div>
                    <div className="overflow-hidden flex-fill">
                      <div className="d-flex align-items-center justify-content-between">
                        <h2 className="counter">{customerData?.total}</h2>
                        <span className="badge bg-danger">
                          {Math.floor(
                            (customerData?.result.active /
                              customerData?.total) *
                            100,
                            2
                          ) || 0}{" "}
                          %
                        </span>
                      </div>
                      <p>Total Customers</p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between border-top mt-3 pt-2">
                    <p className="mb-0">
                      Active :{" "}
                      <span className="text-dark fw-semibold">
                        {customerData?.result.active || 0}
                      </span>
                    </p>
                    <span className="text-light">|</span>
                    <p className="mb-0">
                      Inactive :{" "}
                      <span className="text-dark fw-semibold">
                        {customerData?.result.inActive || 0}
                      </span>
                    </p>
                  </div>
                </div>
              </Card>
            </Col>
            <Col xl={4} sm={6} className="d-flex">
              <Card className="flex-fill animate-card border-0">
                <CardBody>
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-xl me-2 bg-warning-transparent p-1">
                      <img src={staff} alt="img" />
                    </div>
                    <div className="overflow-hidden flex-fill">
                      <div className="d-flex align-items-center justify-content-between">
                        <h2 className="counter">
                          {fillerCount?.active + fillerCount?.inActive || 0}
                        </h2>
                        <span className="badge bg-warning">
                          {Math.floor(
                            (fillerCount?.active /
                              (fillerCount?.active + fillerCount?.inActive)) *
                            100,
                            2
                          ) || 0}{" "}
                          %
                        </span>
                      </div>
                      <p>Total Filler / Staff</p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between border-top mt-3 pt-2">
                    <p className="mb-0">
                      Active :{" "}
                      <span className="text-dark fw-semibold">
                        {fillerCount?.active || 0}
                      </span>
                    </p>
                    <span className="text-light">|</span>
                    <p className="mb-0">
                      Inactive :{" "}
                      <span className="text-dark fw-semibold">
                        {fillerCount?.inActive || 0}
                      </span>
                    </p>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col xl={4} sm={6} className="d-flex">
              <Card className="flex-fill animate-card border-0">
                <CardBody>
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-xl me-2 bg-secondary-transparent p-1">
                      <img src={nozzle} alt="img" />
                    </div>
                    <div className="overflow-hidden flex-fill">
                      <div className="d-flex align-items-center justify-content-between">
                        <h2 className="counter">{nozzelCount?.total}</h2>
                        <span className="badge bg-skyblue">
                          {Math.floor(
                            (nozzelCount?.active / nozzelCount?.total) * 100,
                            4
                          ) || 0}{" "}
                          %
                        </span>
                      </div>
                      <p>Total Nozzle</p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between border-top mt-3 pt-2">
                    <p className="mb-0">
                      Active :{" "}
                      <span className="text-dark fw-semibold">
                        {nozzelCount?.active || 0}
                      </span>
                    </p>
                    <span className="text-light">|</span>
                    <p className="mb-0">
                      Inactive :{" "}
                      <span className="text-dark fw-semibold">
                        {nozzelCount?.inActive || 0}
                      </span>
                    </p>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
